export default "__VITE_ASSET__DQyAupxY__"